import { useContext } from 'react'
import { ConfirmArgs, ConfirmDialogContext } from 'components/ConfirmDialog'

export default function useConfirm() {
  const context = useContext(ConfirmDialogContext)
  return (args: ConfirmArgs): Promise<boolean> => context.openConfirmation(args)
}
